import React from "react";
import { Route, Routes } from "react-router-dom";
// import { OrderDetails } from "./details/";
import { SuppliersList } from "./list";
import { SupplierInfo } from "./details";

const SuppliersModule = () => {
  return (
    <Routes>
      <Route index element={<SuppliersList />} />
      <Route path="details/:supplierId" element={<SupplierInfo />} />
    </Routes>
  );
};

export default SuppliersModule;
